import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Action, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchERPEquipmentMapppingOperations({ erpEquipmentMappingOperationsParams }) {
  try {
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: true }));
    const { data } = yield call(api.get, {
      route: 'ERPEquipmentMapping/GetAllERPEquipmentMappingData',
      params: erpEquipmentMappingOperationsParams,
    });
    const erpEquipmentMapppingOperationData = data;
    yield put(Action.setERPEquipmentMapppingOperations({ erpEquipmentMapppingOperationData }));
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
  } catch (err) {
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
    notification('error', err, '');
    console.warn(err);
  }
}

function* addUpdateERPEquipmentMapppingOperation({
  actionName,
  erpEquipmentMappingOperationObj,
  erpEquipmentMappingOperationsParams,
}) {
  try {
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: true }));
    const apiRoute =
      actionName === CONSTANT_VARIABLES.UPDATE
        ? `ERPEquipmentMapping/${erpEquipmentMappingOperationObj.id}`
        : 'ERPEquipmentMapping';
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: apiRoute,
      data: erpEquipmentMappingOperationObj,
    });
    yield put(Action.fetchERPEquipmentMapppingOperations({ erpEquipmentMappingOperationsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.ERP_EQUIPMENT_MAPPING_CREATED
        : CONSTANT_VARIABLES.ERP_EQUIPMENT_MAPPING_UPDATED,
      ''
    );
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
  } catch (err) {
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
    notification('error', err.toString(), '');
    console.warn(err);
  }
}

function* deleteERPEquipmentMapppingOperation({ erpEquipmentMappingId, erpEquipmentMappingOperationsParams }) {
  try {
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: true }));
    yield call(api.delete, {
      route: `ERPEquipmentMapping/${erpEquipmentMappingId}`,
    });
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
    yield put(Action.fetchERPEquipmentMapppingOperations({ erpEquipmentMappingOperationsParams }));
    notification('success', CONSTANT_VARIABLES.ERP_EQUIPMENT_MAPPING_DELETED, '');
  } catch (err) {
    yield put(
      Action.setERPEquipmentMapppingOperationLoaderStatus({ erpEquipmentMappingOperationsLoaderStatus: false })
    );
    notification('err', err.toString(), '');
    console.warn(err);
  }
}

function* fetchErpExist({ erpParams, funcCallback }) {
  try {
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ showLoader: true }));
    const { field, value, id } = erpParams;

    const { data } = yield call(api.get, {
      route: 'ERPEquipmentMapping/erpExists/' + field + '/' + value + '/' + id,
    });
    const erpIdSearchData = data;
    if (funcCallback) funcCallback(data);
    yield put(Action.setErpExist({ erpIdSearchData }));
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Action.setERPEquipmentMapppingOperationLoaderStatus({ showLoader: false }));
    console.warn(err);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ERP_EQUIPMENT_MAPPING_OPERATION, fetchERPEquipmentMapppingOperations),
    takeLatest(ActionTypes.ADD_UPDATE_ERP_EQUIPMENT_MAPPING_OPERATION, addUpdateERPEquipmentMapppingOperation),
    takeLatest(ActionTypes.DELETE_ERP_EQUIPMENT_MAPPING_OPERATION, deleteERPEquipmentMapppingOperation),
    takeLatest(ActionTypes.FETCH_ERP_EXIST, fetchErpExist),
  ]);
}
